module.exports = __webpack_public_path__ + "static/media/exterior_ghost_sign_style_layout_2019.4e53cd00.webp";